<template>
  <div id="add_broadcast" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Direct Chats</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- {{agentSession}} -->
          <div class="col-sm-12 col-md-12">
            <div class="row">
              <div class="col-sm-4 text-left" v-show="false">
                <div class="view-icons">
                  <a
                    @click.prevent="changeDestination(1)"
                    :class="'grid-view btn btn-link '+((broadcastParam.is_group==1)?'active':'')"
                  >
                    <i class="fa fa-users"></i>
                  </a>
                  <a
                    @click.prevent="changeDestination(0)"
                    :class="'grid-view btn btn-link '+((broadcastParam.is_group==0)?'active':'')"
                  >
                    <i class="fa fa-user"></i>
                  </a>
                </div>
              </div>
              <div class="col-sm-12">
                <label class="menu-title text-wrap">
                  <b>
                    <i class="fa fa-user"></i>
                    {{agentSession.license_name}}
                    <br />
                    <i class="fa fa-phone"></i>
                    {{agentSession.license_phone_number}}
                  </b>
                </label>
              </div>
            </div>
          </div>
          <!-- {{broadcastParam}} -->
          <div class="col-sm-12 col-md-12">
            <div class="input-group m-b-30">
              <div class="input-group-prepend">
                <button
                  class="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-if="uploadMessageSupportSelected==''"
                >Options</button>
                <button
                  class="btn btn-outline-secondary dropdown-toggle"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  v-else
                >{{uploadMessageSupportSelected}}</button>
                <div class="dropdown-menu">
                  <a
                    @click.prevent="updateMessageSupportCurrent(opt)"
                    class="dropdown-item"
                    href="#"
                    v-for="(opt,index) in messageTypeOptionsSupport"
                    :key="index"
                  >
                    <i
                      class="text-success fa fa-check-circle"
                      v-if="uploadMessageSupportSelected==opt"
                    ></i>
                    {{opt}}
                  </a>
                </div>
              </div>
              <multiselect
                v-if="broadcastParam.is_group==1"
                :class="'form-control'"
                v-model="selectedContactGroup"
                id="ajax"
                label="name"
                track-by="id"
                placeholder="Type to search group"
                open-direction="bottom"
                :custom-label="customLabelGroup"
                :options="contactOptionsGroup"
                :multiple="true"
                :searchable="true"
                :loading="isLoadingGroup"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :options-limit="300"
                :limit="3"
                :limit-text="limitText"
                :max-height="600"
                :show-no-results="true"
                :hide-selected="true"
                @search-change="asyncFindGroup"
                :show-labels="false"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span>{{ option.name }}</span>
                    <span class="custom__remove" @click="remove(option)">❌</span>
                  </span>
                </template>
                <template slot="clear" slot-scope="props">
                  <div
                    class="multiselect__clear"
                    v-if="selectedContactGroup.length"
                    @mousedown.prevent.stop="clearAll(props.search)"
                  ></div>
                </template>
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <multiselect
                v-if="broadcastParam.is_group==0"
                :class="'form-control'"
                v-model="selectedContact"
                id="ajax"
                label="first_name"
                track-by="phone_number"
                placeholder="Type to search contact"
                open-direction="bottom"
                :custom-label="customLabel"
                :options="contactOptions"
                :multiple="true"
                :searchable="true"
                :loading="isLoading"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="false"
                :options-limit="300"
                :limit="3"
                :limit-text="limitText"
                :max-height="600"
                :show-no-results="true"
                :hide-selected="true"
                @search-change="asyncFind"
                :show-labels="false"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span>{{ option.first_name }}</span>
                    <span class="custom__remove" @click="remove(option)">❌</span>
                  </span>
                </template>
                <template slot="clear" slot-scope="props">
                  <div
                    class="multiselect__clear"
                    v-if="selectedContact.length"
                    @mousedown.prevent.stop="clearAll(props.search)"
                  ></div>
                </template>
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
              <!-- <pre class="language-json"><code>{{ selectedContact  }}</code></pre> -->
              <!-- <span class="input-group-append">
                <button class="btn btn-primary">Search</button>
              </span>-->
            </div>
          </div>
          <div class="col-sm-12 col-md-12" v-if="uploadMessageSupportSelected!='text only'">
            <!-- <form id="js-upload-form"> -->
            <div class="col-md-12">
              <span style="margin-left:10px;">Message type:</span>
              <button
                class="btn btn-outline-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                v-if="uploadMessageType==''"
              >Options</button>
              <button
                class="btn btn-outline-secondary dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                v-else
              >{{uploadMessageType}}</button>
              <div class="dropdown-menu">
                <a
                  @click.prevent="updateMessageTypeCurrent(opt)"
                  class="dropdown-item"
                  href="#"
                  v-for="(opt,index) in messageTypeOptionsUpload"
                  :key="index"
                >
                  <i class="text-success fa fa-check-circle" v-if="uploadMessageType==opt"></i>
                  {{opt}}
                </a>
              </div>
              <div v-show="files.length==0" class="col-md-12 upload-drop-zone" id="drop-zone">
                <center>
                  <i class="fa fa-cloud-upload fa-2x"></i>
                  <span class="upload-text">
                    <label :for="name">
                      Just drag and
                      drop file here
                    </label>
                  </span>
                </center>
              </div>
            </div>
            <div class="col-md-12">
              <!-- {{files}} -->
              <!-- <h4 v-if="files.length">Uploading</h4> -->
              <ul class="upload-list" v-if="files.length">
                <li v-for="file in files" :key="file.id" class="file-list">
                  <div class="upload-wrap">
                    <div class="file-name">
                      <!-- <i class="fa fa-photo"></i> -->
                      <img style="width:30px;" v-if="file.thumb" :src="file.thumb" />
                      {{file.name}}
                    </div>
                    <div class="file-size">{{formatSizes(file.size)}}</div>
                    <div class="file-close">
                      <span class="text-danger" v-if="file.error">{{file.error}}</span>
                      <span v-else-if="file.success">
                        <i class="text-success fa fa-check-circle"></i>
                      </span>
                      <span v-else-if="file.active">active</span>
                      <span v-else></span>

                      <a href="#" @click.prevent="$refs.uploadbc.remove(file)" class="text-warning">
                        <i class="fa fa-trash-o"></i>
                      </a>
                    </div>
                  </div>

                  <div
                    class="progress progress-xs progress-striped"
                    v-if="file.active || file.progress !== '0.00'"
                  >
                    <div
                      class="progress-bar bg-success"
                      role="progressbar"
                      :style="{width: file.progress + '%'}"
                    ></div>
                  </div>
                  <div
                    class="upload-process"
                    v-if="file.active || file.progress !== '0.00'"
                  >{{file.progress}}% done</div>
                </li>
              </ul>
            </div>
            <!-- </form> -->

            <div class="col-sm-12 col-md-12">
              <div class="alert alert-warning">
                <ul>
                  <li>Support files: {{extensions}}</li>
                  <li>MaxSize: 10Mb</li>
                </ul>
              </div>
            </div>
            <div class="col-sm-12" v-show="($refs.uploadbc && $refs.uploadbc.active==false) ">
              <div class="submit-section">
                <div class="input-group mb-3">
                  <div class="input-group-prepend" v-show="false">
                    <file-upload-bc
                      :add-index="true"
                      class="btn btn-outline-secondary"
                      :data="objFilesMessageHandler"
                      :post-action="uploadUrl"
                      :multiple="false"
                      :headers="headers"
                      :drop="true"
                      :drop-directory="true"
                      v-model="files"
                      @input-filter="inputFilter"
                      @input-file="inputFile"
                      ref="uploadbc"
                      :maximum="maximumUpload"
                      :extensions="extensions"
                    >
                      <img src="@/assets/attachment.png" alt />
                    </file-upload-bc>
                  </div>

                  <div class="input-group-append">
                    <button
                      v-if="false"
                      @click.prevent="$refs.uploadbc.active = true"
                      class="btn btn-outline-secondary"
                      type="button"
                    >Upload File</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="$refs.uploadbc && $refs.uploadbc.active==true">
              <div class="col-sm-2">
                <Skeleton :height="'40px'" :count="1" />
              </div>
              <div class="col-sm-2">
                <Skeleton :height="'40px'" :count="1" />
              </div>
              <div class="col-sm-6">
                <Skeleton :height="'40px'" :count="1" />
              </div>
              <div class="col-sm-2">
                <Skeleton :height="'40px'" :count="1" />
              </div>
            </div>
          </div>

          <div class="col-sm-12 col-md-12">
            <!-- {{broadcastParam}} -->
            <div class="message-bar">
              <div class="message-inner">
                <a class="link attach-icon" @click.prevent="emojiToggle()">
                  <img style="width:30px;" src="@/assets/emoji.png" alt />
                </a>
                <div class="message-area">
                  <div class="input-group">
                    <Emoji
                      :open="emojiAttr.open"
                      :width="emojiAttr.width"
                      :height="emojiAttr.height"
                      searchLabel="Search emoji here"
                      @click="selectedEmoji"
                    />
                    <textarea
                      ref="messagebox"
                      class="form-control"
                      v-model="broadcastParam.message.text"
                      :placeholder="'Type message...'"
                      @keydown="inputHandler"
                    ></textarea>
                    <span class="input-group-append">
                      <button
                        @click.prevent="bcMessageHandler"
                        class="btn btn-custom"
                        type="button"
                      >
                        <i class="fa fa-bullhorn"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- {{agentSession}} -->
          <!-- <h5>Recent Conversations</h5> -->

          <!-- <div class="submit-section">
            <button class="btn btn-primary submit-btn">Submit</button>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { APICore, APICoreV2 } from "@/utils/servicesApi";
import { getXAuthAgent, getXAuthToken, getAgentSession } from "@/utils/auth";

import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";
import FileUpload from "vue-upload-component";
import Cropper from "cropperjs";
import ImageCompressor from "@xkeshi/image-compressor";
import { VueChatEmoji, emojis } from "vue-chat-emoji";
require("vue-chat-emoji/dist/vue-chat-emoji.min.css");
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import {
  formatDate,
  formatDateForMessage,
  getWhatsappNumberFromJid,
  formatSizes
} from "@/utils/helper";
export default {
  components: {
    Skeleton,
    FileUploadBc: FileUpload,
    Emoji: VueChatEmoji,
    Multiselect
  },
  data() {
    return {
      contactListGroupParam: {
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      },
      broadcastParam: {
        title: "",
        license_id: "",
        provider: "whatsapp",
        to_group: [],
        to: [],
        is_group: 0, //for group set 1, for personal set 0
        message: {
          text: "",
          message_type: "text", //text,image,document
          file_url: ""
        },
        sending_options: 1,
        is_send: 1,
        is_not_save: 1 //tidak disimpan ke daftar bc
      },
      contactListParam: {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      },
      selectedContactGroup: [],
      contactOptionsGroup: [],
      isLoadingGroup: false,
      selectedContact: [],
      contactOptions: [],
      isLoading: false,
      textMessage: "",
      objFilesMessageHandler: {
        file: null,
        // message_media: messaegMedia,
        message_type: ""
      },
      messageTypeOptionsSupport: ["text only", "media"],
      uploadMessageSupportSelected: "text only",
      messageTypeOptionsUpload: ["image", "document"],
      uploadMessageType: "image",
      caption: "",
      name: "file",
      thumbUpload: [],
      uploadAuto: true,
      uploadUrl:
        // process.env.VUE_APP_BASE_API + this.APICore() + "/omni/room/send-file",
        process.env.VUE_APP_BASE_API +
        this.APICore() +
        "/omni/room/only-upload-file",
      maximumUpload: 1,
      accept: "image/png,image/gif,image/jpeg,image/webp",
      extensions: "gif,jpg,jpeg,png,webp,zip,pdf,xls,xlsx, doc, docx",
      minSize: 1024,
      size: 1024 * 1024 * 10,
      files: [],
      emojiAttr: {
        open: false,
        width: "0%",
        height: "0px"
      },

      newData: [],
      currentGroupId: "",
      groupListParam: {
        name: "",
        page: 0,
        perPage: 1000
      }
    };
  },
  watch: {
    uploadMessageSupportSelected: {
      handler: function(val, oldVal) {
        if (val == "media") {
          this.broadcastParam.message.message_type = this.uploadMessageType;
        } else {
          this.files = [];
          this.broadcastParam.message.file_url = "";
          this.broadcastParam.message.message_type = "text";
        }
      },
      deep: true
    },
    uploadMessageType: {
      handler: function(val, oldVal) {
        if (val != "") {
          this.broadcastParam.message.message_type = val;
        } else {
          this.broadcastParam.message.message_type = "text";
        }
      },
      deep: true
    },
    isShowBroadcast: {
      handler: function(val, oldVal) {
        if (val == true) {
        }
      },
      deep: true
    },
    selectedContact: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: row.phone_number,
              first_name: row.first_name
            };
            this.broadcastParam.to.push(newDest);
          });
        } else {
          this.broadcastParam.to = [];
        }
      },
      deep: true
    },
    selectedContactGroup: {
      handler: function(val, oldVal) {
        if (val.length) {
          this.broadcastParam.to_group = [];
          let newDest = {};
          val.forEach((row, index) => {
            newDest = {
              id: row.id,
              phone_number: 0,
              first_name: row.name
            };
            this.broadcastParam.to_group.push(newDest);
          });
        } else {
          this.broadcastParam.to_group = [];
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["agentSession"]),
    isShowBroadcast() {
      return this.$store.state.omniroom.isShowBroadcast;
    },
    headers() {
      return {
        "X-Auth-Token": "Bearer " + this.getXAuthToken(),
        "X-Auth-Agent": "Bearer " + this.getXAuthAgent()
      };
    }
  },
  methods: {
    async buildDestinationFromGroup() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      await this.$store
        .dispatch("contact/getContactList", this.contactListParam)
        .then(response => {
          let { data } = response;
          data.forEach((rowCon, ind) => {
            let arrCon = {
              id: rowCon.id,
              phone_number: rowCon.phone_number
            };
            this.broadcastParam.to.push(arrCon);
          });
        });
    },
    customLabelGroup({ name }) {
      return `${name}`;
    },
    asyncFindGroup(query) {
      this.isLoadingGroup = true;
      this.contactListGroupParam.name = query;
      this.$store
        .dispatch("contact/getGroupList", this.contactListGroupParam)
        .then(response => {
          this.isLoadingGroup = false;
          this.contactOptionsGroup = response.data;
          // console.log("query: ", query);
          // console.log("contactOptionsGroup: ", this.contactOptionsGroup);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoadingGroup = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    changeDestination(isGroup) {
      this.broadcastParam.is_group = isGroup;
      this.broadcastParam.to = [];
      this.broadcastParam.to_group = [];
      this.selectedContactGroup = [];
      this.selectedContact = [];
      this.contactListParam = {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      };
      this.contactListGroupParam = {
        name: "",
        group_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      };
    },
    async bcMessageHandler() {
      if (this.broadcastParam.is_group == 1) {
        if (this.broadcastParam.to_group.length == 0) {
          //error no destination
          // error
          this.$fire({
            title: "Error",
            text: "Destination is required!",
            type: "error",
            timer: 2000
          }).then(r => {});
          return;
        }
        await this.buildDestinationFromGroup();
      }

      //validasi data
      if (
        this.broadcastParam.to.length == 0 &&
        this.broadcastParam.to_group.length == 0
      ) {
        //error no destination
        // error
        this.$fire({
          title: "Error",
          text: "Destination is required!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }
      if (
        this.broadcastParam.message.message_type != "text" &&
        this.broadcastParam.message.file_url == ""
      ) {
        //error no media
        this.$fire({
          title: "Error",
          text:
            "File is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      if (
        this.broadcastParam.message.message_type == "text" &&
        this.broadcastParam.message.text.trim() == ""
      ) {
        //error no text for type text
        this.$fire({
          title: "Error",
          text:
            "Text is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000
        }).then(r => {});
        return;
      }

      // return;

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        // console.log("rrrr", r);
        // return;
        if (r.value == true) {
          this.broadcastParam.license_id = this.agentSession.license_id;
          this.isSending = await true;
          this.emojiToggle(false);
          var agentName =
            this.agentSession.is_owner == 1
              ? ""
              : "\n~" + this.agentSession.first_name;
          this.broadcastParam.message.text =
            this.broadcastParam.message.text + agentName;
          this.broadcastParam.message.text = await this.remove_tags(
            this.broadcastParam.message.text
          );
          this.broadcastParam.title =
            "via ChatApp - by:" + this.agentSession.first_name;

          await this.$store
            .dispatch("omniwa/sendBroadcast", this.broadcastParam)
            .then(response => {
              this.files = [];
              this.selectedContactGroup = [];
              this.selectedContact = [];
              this.isSending = false;
              this.broadcastParam = {
                provider: "whatsapp",
                to_group: [],
                to: [],
                // is_group: this.broadcastParam.is_group, //for group set 1, for personal set 0
                is_group: 0, //for group set 1, for personal set 0
                message: {
                  text: "",
                  message_type: this.broadcastParam.message.message_type, //text,image,document
                  file_url: ""
                },
                sending_options: 1,
                is_send: 1,
                is_not_save: 1
              };
              this.$fire({
                title: "Success",
                text: "Your message is on the way...",
                type: "success",
                timer: 2000
              }).then(r => {});
            })
            .catch(() => {
              this.isSending = false;
            });
        }
      });
    },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    inputHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.bcMessageHandler();
      }
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ first_name, phone_number }) {
      return `${first_name} – ${phone_number}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.keywords = query;
      this.$store
        .dispatch("contact/getContactList", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data;
          console.log("query: ", query);
          console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAll() {
      this.selectedContact = [];
    },
    emojiToggle(isClosed) {
      // console.log("clicked toggle");
      if (typeof isClosed == "undefined") {
        if (this.emojiAttr.open == true) {
          this.emojiAttr.open = false;
        } else {
          this.emojiAttr.open = true;
        }
      } else {
        this.emojiAttr.open = isClosed;
      }

      if (this.emojiAttr.open == true) {
        this.emojiAttr.width = "96%";
        this.emojiAttr.height = "250px";
      } else {
        this.emojiAttr.width = "0%";
        this.emojiAttr.height = "0px";
      }

      // console.log("this.emojiAttr.open:: ", this.emojiAttr.open);
    },
    selectedEmoji(args) {
      this.broadcastParam.message.text += args.emoji;
      // console.log(args); /* return {...}*/
    },
    updateMessageSupportCurrent(msgType) {
      this.uploadMessageSupportSelected = msgType;
    },
    updateMessageTypeCurrent(msgType) {
      this.uploadMessageType = msgType;
    },
    inputFileHandler(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.$refs.uploadbc.active = true;
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      console.log("newFile, oldFile", newFile, oldFile);
      if (newFile && !oldFile) {
        // Before adding a file
        // 添加文件前
        // Filter system files or hide files
        // 过滤系统文件 和隐藏文件
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        // 过滤 php html js 文件
        if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
          return prevent();
        }

        // var liContainer = document.getElementById("drag_files");
        // var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal",isShowModal)
        // if (isShowModal == false) {
        //   // document.getElementById("btnDragFiles").click(); // Click on the checkbox
        // }
        // Automatic compression
        // 自动压缩
        if (
          newFile.file &&
          newFile.error === "" &&
          newFile.type.substr(0, 6) === "image/" &&
          this.autoCompress > 0 &&
          this.autoCompress < newFile.size
        ) {
          // console.log("compressing", newFile, oldFile);

          newFile.error = "compressing";
          const imageCompressor = new ImageCompressor(null, {
            convertSize: 1024 * 1024,
            maxWidth: 512,
            maxHeight: 512
          });
          imageCompressor
            .compress(newFile.file)
            .then(file => {
              this.$refs.uploadbc.update(newFile, {
                error: "",
                file,
                size: file.size,
                type: file.type
              });
            })
            .catch(err => {
              this.$refs.uploadbc.update(newFile, {
                error: err.message || "compress"
              });
            });
        }
      }
      console.log("humb newFile, oldFile: ", newFile, oldFile);
      if (
        newFile &&
        newFile.error === "" &&
        newFile.file &&
        (!oldFile || newFile.file !== oldFile.file)
      ) {
        // Create a blob field
        // 创建 blob 字段
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        // 缩略图
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
      // image size
      // image 尺寸
      if (
        newFile &&
        newFile.error === "" &&
        newFile.type.substr(0, 6) === "image/" &&
        newFile.blob &&
        (!oldFile || newFile.blob !== oldFile.blob)
      ) {
        newFile.error = "image parsing";
        let img = new Image();
        img.onload = () => {
          this.$refs.uploadbc.update(newFile, {
            error: "",
            height: img.height,
            width: img.width
          });
        };
        img.οnerrοr = e => {
          console.log("errorr", e);
          this.$refs.uploadbc.update(newFile, { error: "parsing image size" });
        };
        img.src = newFile.blob;
      }
    },
    inputFile(newFile, oldFile) {
      // console.log("inputFile:oldddd", oldFile);
      // console.log("inputFile:newf", newFile);
      if (newFile && oldFile) {
        console.log("oldddd", oldFile);
        console.log("newf", newFile);
        // update
        if (newFile.active && !oldFile.active) {
          //buildData
          let dataArr = {
            message_type: this.uploadMessageType
          };
          // this.$store.dispatch("omniwa/actFilesMessageHandler", dataArr);
          this.objFilesMessageHandler = dataArr;
          this.$refs.uploadbc.update(newFile, { data: dataArr });

          // beforeSend
          // min size
          if (
            newFile.size >= 0 &&
            this.minSize > 0 &&
            newFile.size < this.minSize
          ) {
            this.$refs.uploadbc.update(newFile, { error: "size" });
          }
        }
        if (newFile.progress !== oldFile.progress) {
          // progress
          console.log("progress", newFile.progress);
        }
        if (newFile.error && !oldFile.error) {
          console.log("err", newFile.error.response);
          console.log("newFile", newFile);
          this.$refs.uploadbc.update(newFile, { progress: 0 });

          // error
          this.$fire({
            title: "Error",
            text: newFile.response.msg,
            type: "error",
            timer: 1000
          }).then(r => {});
        }
        if (newFile.success && !oldFile.success) {
          this.broadcastParam.message.file_url = newFile.response.data.url;
          this.caption = "";
          this.thumbUpload.push(newFile.thumb);
          // success
          // console.log("this.thumbUpload", this.thumbUpload);
          console.log("success", newFile.success, newFile);
        }
      }
      if (!newFile && oldFile) {
        this.broadcastParam.message.file_url = "";
        // remove
        if (oldFile.success && oldFile.response.id) {
        }
      }
      // Automatically activate upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (this.uploadAuto && !this.$refs.uploadbc.active) {
          this.$refs.uploadbc.active = true;
        }
      }
    },
    formatSizes(bytes) {
      return formatSizes(bytes);
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    getXAuthToken() {
      return getXAuthToken();
    },
    getXAuthAgent() {
      return getXAuthAgent();
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    APICoreV2() {
      return APICoreV2();
    },
    APICore() {
      return APICore();
    }
  },
  async created() {},
  beforeDestroy() {},
  mounted() {},
  name: "directChat"
};
</script>


// WEBPACK FOOTER //
// src/views/omni/broadcast.vue